import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService, CookieService, UserDTO } from 'psd-common';
import { environment } from '../../../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'central-login-app-header',
    templateUrl: 'central-login-app-header.component.html'
})
export class CentralLoginAppHeaderComponent implements OnInit {
    @Input('currentUser') currentUser: UserDTO;

    constructor(@Inject(DOCUMENT) private document: Document,
                private authenticationService: AuthenticationService,
                private renderer: Renderer2,
                private router: Router,
                private cookieService: CookieService) {
    }

    ngOnInit() {
        this.renderer.removeClass(this.document.body, 'login');
        this.renderer.addClass(this.document.body, 'central-login__dashboard');
    }

    logOut() {
        let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
        this.authenticationService.logout(environment, centralAccessToken).subscribe(() => {
            this.router.navigate(['/central-login/login']);
        });
    }

    goToDashboard() {
        this.router.navigate(['/central-login/dashboard']);
    }
}
